import { useState, useEffect } from "react";

import { httpsCallable } from "firebase/functions";
import "react-datepicker/dist/react-datepicker.css";

import { showToast } from "utils/utils";
import { useTranslation } from "react-i18next";
import { useGame } from "context/gameContext";
import { useFunctions } from "reactfire";
import { IonButton, IonItem, IonLabel, IonAvatar, IonImg } from "@ionic/react";

import { useLeague } from "context/leagueContext";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";
import { Md2Check, Md2Loading } from "react-icons-ng/md2";
import { classNames } from "utils/utils";

const User = ({ item }) => {
  const {
    state: { leagueInfo },
  } = useLeague();

  const {
    state: { userGameData },
  } = useGame();

  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const [timerExpired, setTimerExpired] = useState(false);

  const startTimer = () => {
    setTimerExpired(true);
    const timerPeriod = 50000;

    const timer = setTimeout(() => {
      setTimerExpired(false);
    }, timerPeriod);

    return () => {
      clearTimeout(timer);
    };
  };

  const functions = useFunctions();

  const inviteUserToLeague = httpsCallable(functions, "inviteToLeague", {
    timeout: 530000,
  });

  const callInviteUser = async (userId) => {
    setIsLoading(true);

    let data = {
      type: "invite",
      toUserId: userId,
      fromUser: {
        name: userGameData?.nickname
          ? userGameData?.nickname
          : userGameData?.name,
        id: userGameData?.id,
        photo: userGameData?.photo,
      },
      leagueId: leagueInfo?.id,
    };

    inviteUserToLeague(data)
      .then((result) => {
        setIsLoading(false);
        startTimer();
        showToast("Invite sent!");
      })
      .catch((error) => {
        setIsLoading(false);
        showToast("Invite not sent. Please try again");
      });
  };

  return (
    <IonItem>
      {item?.photo && (
        <IonAvatar slot="start">
          <IonImg src={item?.photo} />
        </IonAvatar>
      )}
      <IonLabel>
        <h2>{item?.name}</h2>
      </IonLabel>
      {!timerExpired ? (
        <IonButton
          disabled={isLoading || timerExpired}
          onClick={() => callInviteUser(item?.objectID)}
          slot="end"
          color="dark"
          mode="ios"
          fill="outline"
          expand="block"
          className="customButtonNew rounded-md-8 h-8"
        >
          <IonLabel>{t("tournament.invite.button")}</IonLabel>
          <IonLabel slot="end">
            <Md2Loading
              className={classNames(
                "ml-1 h-6 w-6",
                isLoading ? "animate-spin" : "hidden"
              )}
            />
          </IonLabel>
        </IonButton>
      ) : (
        <IonLabel slot="end">
          <Md2Check className="mr-4 h-6 w-6" />
        </IonLabel>
      )}
    </IonItem>
  );
};

export default User;
